import { c as _c } from "react/compiler-runtime";
import type { UploadHookControl } from '@better-upload/client';
type PasteUploadAreaProps = {
  children: React.ReactNode;
  control: UploadHookControl<true>;
  metadata?: Record<string, unknown>;
  uploadOverride?: (...args: Parameters<UploadHookControl<true>['upload']>) => void;

  // Add any additional props you need.
};
export function PasteUploadArea(t0) {
  const $ = _c(8);
  const {
    children,
    control: t1,
    metadata,
    uploadOverride
  } = t0;
  const {
    upload,
    isPending
  } = t1;
  let t2;
  if ($[0] !== isPending || $[1] !== metadata || $[2] !== upload || $[3] !== uploadOverride) {
    t2 = e => {
      const files = e.clipboardData.files;
      if (files.length > 0 && !isPending) {
        if (uploadOverride) {
          uploadOverride(files, {
            metadata
          });
        } else {
          upload(files, {
            metadata
          });
        }
      }
    };
    $[0] = isPending;
    $[1] = metadata;
    $[2] = upload;
    $[3] = uploadOverride;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== children || $[6] !== t2) {
    t3 = <div onPasteCapture={t2}>{children}</div>;
    $[5] = children;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}